/** @format */
import { filters } from '../utils/filters';
import { $utils } from '@/utils/publicUtils';

// 列处理
export default {
	props: {
		// 背景颜色
		tableRowFunction: {
			type: Function,
		},
		// 单元格颜色
		tableCellClassName: {
			type: Function,
		},
	},
	computed: {
		columnMap() {
			const columnMap = {};
			this.columns.forEach((column) => {
				columnMap[column.prop] = column;
			});
			return columnMap;
		},
		displayFieldProps() {
			const columns = [];
			this.displayFields.forEach((field) => {
				columns.push(field.prop);
			});
			return columns;
		},
		tableColumns() {
			if (this.displayField && $utils.isNotEmpty(this.displayFields)) {
				const columns = [];
				const length = this.displayFields.length;
				let j = 0;
				for (let i = 0; i < length; i++) {
					const field = this.displayFields[i];
					const c = this.columnMap[field.prop];
					if ($utils.isEmpty(c)) {
						continue;
					}
					const column = JSON.parse(JSON.stringify(c));
					if (field.width) {
						column.width = field.width;
						// bug-8774
						j++;
						if (j !== length) {
							column.width = field.width;
						}
					}
					columns.push(column);
				}
				return columns;
			} else {
				return this.columns;
			}
		},
	},
	methods: {
		/**
		 * 判断序号列是否固定
		 */
		indexFixed() {
			if ($utils.isEmpty(this.tableColumns)) return false;
			for (let i = 0; i < this.tableColumns.length; i++) {
				const column = this.tableColumns[i];
				const bool = this.showColumn(column);
				if (!bool) continue;
				const cFixed = this.fieldFixed(column);
				if (cFixed && cFixed !== 'right') return true;
			}
			return false;
		},
		/**
		 * 是否固定列
		 * @param {*} column
		 */
		fieldFixed(column) {
			if ($utils.isEmpty(column) || !column.isFixed) return false;
			return column.fixedPosition || true;
		},
		/**
		 * 是否显示字段
		 * @param {*} column
		 */
		showColumn(column) {
			if (this.displayField && $utils.isNotEmpty(this.displayFields)) {
				return this.displayFieldProps.indexOf(column.prop) > -1;
			} else {
				return !$utils.toBoolean(column.hidden, false);
			}
		},
		/**
		 * 获取标签的值
		 * @param {*} options
		 * @param {*} val
		 */
		getOption(options, val, column = {}) {
			return options.find((x) => {
				return (
					x[column['valueKey'] || 'value'] === val ||
					($utils.isNumber(val) && x[column['valueKey'] || 'value'] === `${val}`)
				);
			});
		},
		/**
		 * 根据key值获取对应选项中指定key的数据
		 * @param {*} key
		 * @param {*} options
		 * @param {*} val
		 * @param {*} column
		 */
		getOptionValByName(key, options, val, column = {}) {
			const opt = this.getOption(options, val, column);
			if ($utils.isEmpty(opt) || $utils.isEmpty(key)) return null;
			return opt[key];
		},
		/**
		 * 获取选项设置的颜色
		 * @param {*} options
		 * @param {*} val
		 */
		handleColumnOptionsColor(column, val) {
			const result = {};
			if ($utils.isEmpty(column) || $utils.isEmpty(val)) return result;
			const hasOptionColor = column.hasOptionColor;
			if (hasOptionColor) {
				result.class = 'is-option-color';
			}
			const options = column.options;
			if ($utils.isEmpty(options)) return result;
			const _style = this.getOptionValByName('style', options, val);
			if ($utils.isEmpty(_style)) return result;
			options.forEach((item) => {
				if (item.fontColor) {
					result.class = '';
				} else {
					result.class = 'is-option-color';
				}
			});
			result.style = _style;
			return result;
		},
		/**
		 * 处理列表
		 * @param {*} key
		 * @param {*} options
		 * @param {*} val
		 */
		handleColumnOptions(key, options, val, column = {}) {
			const defaultLabel = column.defaultLabel;
			const opt = this.getOption(options, val, column);
			if (!opt) {
				return defaultLabel || val;
			}
			if (key === 'type') {
				return opt[column['typeKey'] || 'type'];
			} else if (key === 'label') {
				return opt[column['labelKey'] || 'label'] || defaultLabel || val;
			}
			return defaultLabel || val;
		},
		/**
		 * 其他选项
		 * @param {*} row
		 * @param {*} column
		 * @param {*} val
		 */
		handleColumnOtherOption(row, column, val) {
			const label = '';
			if ($utils.isNull(val) || $utils.isEmpty(column) || $utils.isEmpty(column.option_other_id)) return label;
			const _otherVal = row[column.option_other_id];
			if ($utils.isEmpty(_otherVal)) return label;
			const opt = this.getOption(column.options, val, column);
			if ($utils.isEmpty(opt)) return label;
			if (opt.include_other_option) return `:${_otherVal}`;
			return label;
		},
		handleColumnDataConvert(data, separator = ',') {
			if ($utils.isEmpty(data)) {
				return [];
			}
			if ($utils.isArray(data)) {
				return data;
			}
			if ($utils.isString(data)) {
				return data.split(separator);
			} else {
				return [data];
			}
		},
		/**
		 * 处理字段链接
		 */
		handleColumnLink(column, row) {
			if (!column.linkType) {
				return this.$emit('column-link-click', row, column);
			}
			// default、默认是回调
			// open :打开新的页面
			// dialog、打开指定窗口
			// tab 、打开tab
			switch (column.linkType) {
				case 'tab':
					this.$router.push({
						path: column.link,
					});
					break;
				case 'open':
					this.$util.open(column.link);
					break;
				case 'dialog':
					this.$emit('column-link-click', row, column);
					break;
				default:
					this.$emit('column-link-click', row, column);
					break;
			}
		},
		handleColumnFilter(filter, value) {
			return filters[filter](value);
		},
		tableRowClassName({ row, rowIndex }) {
			if (this.tableRowFunction) return this.tableRowFunction({ row, rowIndex });
			else {
				// 自定义单元格样式
				let _className = '';
				_className = 'custom-table-row_bgSty';
				return _className;
			}
		},
	},
};
